import { db } from '../firebaseInit'
import _ from 'lodash'

export default {
  state: {
    projectPhases: [],
    referralSources: [],
    rolesDropDown: [],
    files: [],
    vendorTypes: [],
    builderTitles: []
  },
  mutations: {
    projectPhasesDropDown (state, payload) {
      state.projectPhases = payload
    },
    referralSourcesDropDown (state, payload) {
      state.referralSources = payload
    },
    rolesDropDown (state, payload) {
      state.rolesDropDown = payload
    },
    changeDropDownList (state, payload) {
      state[payload.dropdownName] = _.orderBy(payload.dropdowns)
    },
    filesDropDown (state, payload) {
      state.files = _.orderBy(payload)
    },
    vendorTypesDropDown (state, payload) {
      state.vendorTypes = _.orderBy(payload)
    },
    builderTitlesDropDown (state, payload) {
      state.builderTitles = _.orderBy(payload)
    }
  },
  actions: {
    changeDropDownList ({ commit }, payload) {
      db.collection('settings').doc('dropdowns').update({
        [payload.dropdownName]: payload.dropdowns
      })
      commit('changeDropDownList', payload)
    },
    getDropDowns ({ commit }, payload) {
      db.collection('settings').doc('dropdowns').get().then((doc) => {
        commit('projectPhasesDropDown', doc.data().projectPhases)
        commit('filesDropDown', doc.data().files)
        commit('vendorTypesDropDown', doc.data().vendorTypes)
        commit('builderTitlesDropDown', doc.data().builderTitles)
        commit('rolesDropDown', doc.data().roles)
        commit('referralSourcesDropDown', doc.data().referralSources)
      })
    }
  },
  getters: {
    projectPhases (state) {
      return state.projectPhases
    },
    referralSources (state) {
      return state.referralSources
    },
    rolesDropDown (state) {
      return state.rolesDropDown
    },
    vendorTypes (state) {
      return state.vendorTypes
    },
    builderTitles (state) {
      return state.builderTitles
    },
    files (state) {
      return state.files
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/dropdowns.js